import axios from 'axios';

/** Structured error body returned by the new-dash API on a 400. */
export interface IApiErrorBody {
    success?: boolean;
    message?: string;
    errors?: Record<string, string>;
}

/**
 * Extracts a user-facing message from an axios error, preferring the API's
 * structured `{ message }` body, then the HTTP status, then a fallback.
 */
export const getApiErrorMessage = (err: unknown, fallback: string): string => {
    if (axios.isAxiosError(err)) {
        const data = err.response?.data as IApiErrorBody | undefined;

        if (data?.message) return data.message;
        if (err.response?.status) return `${fallback} (${err.response.status}).`;
    }

    return err instanceof Error ? err.message : fallback;
};

/** Extracts the field-error map from a structured 400 body, if present. */
export const getApiErrorFields = (err: unknown): Record<string, string> | undefined => {
    if (axios.isAxiosError(err)) {
        return (err.response?.data as IApiErrorBody | undefined)?.errors;
    }

    return undefined;
};
